import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { router } from './router';
import './styles.css';

// Umami analytics — self-hosted (PikaPods). No-op if env vars unset, so dev
// runs cost nothing. Cookieless, RGPD-safe by default; we still keep it
// production-only to avoid polluting the dashboard with local hits.
const umamiSrc = import.meta.env.VITE_UMAMI_SRC;
const umamiWebsiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
if (import.meta.env.PROD && umamiSrc && umamiWebsiteId) {
  const s = document.createElement('script');
  s.defer = true;
  s.src = umamiSrc;
  s.setAttribute('data-website-id', umamiWebsiteId);
  document.head.appendChild(s);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err: unknown) => {
        // Never retry 4xx — they are deterministic.
        const status =
          err && typeof err === 'object' && 'status' in err
            ? (err as { status?: number }).status
            : undefined;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
